// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const RightArrow = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M18.813 9.813a1.15 1.15 0 0 0 0-1.626L11.495.868a1.15 1.15 0 1 0-1.627 1.627L16.374 9l-6.506 6.505a1.15 1.15 0 1 0 1.627 1.627l7.318-7.319ZM0 10.15h18v-2.3H0v2.3Z"
			fill="#fff"
		/>
	</svg>
);
export default RightArrow;
